// extracted by mini-css-extract-plugin
module.exports = {"textBox":"TextBox_textBox__2sxiB","textBoxContainer":"TextBox_textBoxContainer__sM5U9"};